module.exports = __webpack_public_path__ + "img/locations.6ad77ff9.png";